'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _ingredientList = require('./ingredient-list.html');

var _ingredientList2 = _interopRequireDefault(_ingredientList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _ingredientList2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    ingredients: '<',
    locked: '<',
    selectedIngredients: '<',
    unitsDisplay: '<',
    unitPerContainer: '<',
    showHeader: '<'
  },
  controller: function () {
    function IngredientListComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, IngredientListComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(IngredientListComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.query = (0, _query.getQuery)();
        this.limitOptions = (0, _query.getLimitOptions)();
      }
    }]);

    return IngredientListComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/ingredient-list/ingredient-list.component.js